import React, { Component } from "react";
import { connect } from "react-redux";
import { Cache } from "aws-amplify";
import { Col, Button, Form, Container } from "react-bootstrap";

import PageTitle from "../../../common/PageTitle";

class CompanyForm extends Component {
  constructor(props) {
    super(props);
    this.accessToekn = "";
  }

  render() {
    this.roleId = Cache.getItem("accessToken");

    return (
      <div>
        <Container className="waa-container">
          <PageTitle pageName="ADD COMPANY" />
          <hr />
          <Col>
            <Form className="waa-form">
              <Form.Group controlId="formCompany">
                <Form.Label>Company Name *</Form.Label>
                <Form.Control type="text" placeholder="Enter Company Name" />
              </Form.Group>
              <Form.Group controlId="formParentCompany">
                <Form.Label>Parent Company *</Form.Label>
                <Form.Control type="text" placeholder="Enter Role Name" />
              </Form.Group>
              <Button size="md" type="submit">
                Submit
              </Button>
            </Form>
          </Col>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
});

export default connect(mapStateToProps)(CompanyForm);
